import styled from '@emotion/styled';

export const BUYER_LAYOUT_HORIZONTAL_PADDING = {
  base: 4,
  md: 8,
  lg: 12,
  xl: 16,
} as const;

export const PageContainer = styled.div`
  max-width: calc(1536px + 8rem); // 8rem for padding inline 4rem
  margin: 0px auto;
  &.product-container {
    @media (min-width: 768px) {
      min-width: 1128px;
    }
  }
  &.recipe-container {
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 0;
    }
  }
`;
